<template>
        <div class='panelitem-container'>
          <div @click="handleClick">
            <div class='panelitem-icon'><Icon :src='icon' classname='panelIcon'/></div>
            <div class='panelitem-title'>{{title}}</div>  
            <div class='panelitem-title' v-if="desc!=''">{{desc}}</div>  
          </div>   
        </div>
</template>
<script>
import Icon from '@/components/icon'
export default {
  name: 'PanelItem',
  props: {
    icon: String,
    title:String,
    desc:{type:String,default:''},
    url:{type:String,default:''},
    paramstr:{type:String,default:''},
  },
  components:{
      Icon
  },
  methods:{
    handleClick(){
            if(this.url!='' && this.paramstr==''){
                 this.$go(this.url) 
            }else if(this.url!='' && this.paramstr!=''){
                const obj = JSON.parse(this.paramstr);
                this.$go({name:this.url.substr(1),params:obj})
            }else{
                this.$emit("click")
            }
      }
  }
}
</script>
<style scoped>
.panelitem-container{display: flex;flex-direction: column;flex: 1 0 21%;padding: 0.25rem;}
.panelitem-container a{color:#333333;}
.panelitem-title{font-size:0.35rem;}
::v-deep .panelIcon{width:0.6rem;height:0.6rem;}
</style>


